import React from 'react';
import styled, { keyframes } from 'styled-components';

const fadeInOut = keyframes`
    0%    { background: rgba(0, 0, 0, 0.35); }
    5%   { background: rgba(0, 0, 0, 0); }
    75% { background: rgba(0, 0, 0, 0); }
    100%  { background: rgba(0, 0, 0, 0.35); }  
`;

const DemoVersionLayer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.35);
  pointer-events: none;
  user-select: none;
  animation: ${fadeInOut} 10s ease-in-out infinite;
`;

const DemoVersionLabel = styled.div`
  color: transparent;
  -webkit-text-stroke: 2px rgba(245, 247, 251, 0.72);
  font-size: clamp(3rem, 10vw, 12rem);
  font-weight: 700;
  letter-spacing: 0.08em;
  line-height: 1.15;
  text-align: center;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.57);
  transform: rotate(-20deg);
`;

const DemoVersion = () => (
  <DemoVersionLayer>
    <DemoVersionLabel>UNLICENSED DEMO VERSION</DemoVersionLabel>
  </DemoVersionLayer>
);

export default DemoVersion;
